import React from 'react';
import { CircularProgress } from '@mui/material';
import useSettings from '../hooks/useSettings';

interface SettingsLoaderProps {
  children: React.ReactNode;
}

const SettingsLoader: React.FC<SettingsLoaderProps> = ({ children }) => {
  const { loading } = useSettings();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  return <>{children}</>;
};

export default SettingsLoader;